var router = require('pjax').Router;
var allocations = require('./allocations.js');
var funds = require('./funds.js');
var fund = require('./fund.js');

router.get('funding/allocation', allocations);
router.get('funding/fund', funds);
router.get('funding/fund/:any', fund);
